import { applyStepsWithConfig, fakeOnboardingStatus } from '../../e2e/merchant.utils';
import { signupStepConfig } from '../signup.fixture';
import { productsStepConfig } from '../products.fixture';
import { storeDetailsStepConfig } from '../store-details.fixture';
import { companyRegistrationStepConfig } from '../company-registration.fixture';
import { vatRegistrationStepConfig } from '../vat-registration.fixture';
import { stakeholderStepConfig } from '../stakeholder.fixture';
import { bankAccountStepConfig } from '../bank-account.fixture';
import { companyDetailsStepConfig } from '../company-details.fixture';
import { entityTypeStepConfig } from '../entity-type.fixture';

const country = 'NL';
const currentDate = new Date().toISOString();

export const defaultWidgetMerchantDetails = {
  businessInformation: {
    organizationName: 'Super Organization NL',
    subjectToVat: true,
    organizationIsRegistered: true,
    organizationRegistrationId: '12357893',
    vatId: 'NL123456789B12',
    owners: [],
    registeredAddress: {
      streetAddress: 'Klarna Lmtd registered address',
      postalCode: '10553',
      city: 'London',
      region: 'London',
      country,
    },
  },
  storeInformation: {
    stores: [
      {
        storeName: `Klarna ${country} Swag Store`,
        homepageUrl: 'http://klarna.com',
        support_email: 'support@email.com',
        organizationCategory: 'ADULT_SHOES_AND_CLOTHING',
        country,
      },
    ],
  },
  type: 'ESTABLISHED',
};

/**
 * These steps are meant to be applied individually, take "stakeholders" for example:
 * if you wanted to have a mocked merchant for the "APPLICANT" container, you would need a
 * merchant that has added a COM and/or a UBO, so to get that you need to apply each step
 * individually: getMerchantWithSteps(['stakeholderCOM', 'stakeholderUBO']). This is due to the
 * fact that some steps might need their own logic at some point, so this makes it easier to
 * understand how to get a merchant at any given point of the flow: you simply apply the steps
 * you need.
 */
export const applyStepConfig = {
  ...fakeOnboardingStatus(),
  ...signupStepConfig({ country, currentDate }),
  ...productsStepConfig({ country, currentDate }),
  ...storeDetailsStepConfig({ country }),
  ...companyRegistrationStepConfig({ country }),
  ...companyDetailsStepConfig({ country }),
  ...vatRegistrationStepConfig({ country }),
  ...entityTypeStepConfig({ country }),
  ...stakeholderStepConfig({ country }),
  ...bankAccountStepConfig({ country, currencies: ['EUR'] }),
  default: {
    value: defaultWidgetMerchantDetails,
    method: 'spreadProperty',
    path: null,
  },
};

export const getMerchantWithSteps = applyStepsWithConfig(applyStepConfig);
